var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M8.001 0C3.564 0 0 3.564 0 8.001 0 12.436 3.564 16 8.001 16 12.436 16 16 12.436 16 8.001 16 3.564 12.436 0 8.001 0zm3.526 7.165l-.51.507c-.143.146-.362.146-.507 0L9.056 6.218c-.11-.108-.329-.035-.329.146v6c0 .218-.145.364-.364.364h-.726c-.219 0-.364-.146-.364-.364V6.328c0-.145-.181-.256-.327-.145L5.49 7.637c-.143.145-.362.145-.508 0l-.51-.51c-.072-.072-.107-.145-.107-.254 0-.11.035-.182.108-.255l3.272-3.273c.073-.073.183-.108.256-.108.108 0 .181.035.254.108l3.272 3.273c.073.073.11.145.11.255 0 .146-.037.219-.11.292z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.814c62ddbe8704e0de810030f57048b1.svg";
export { ForwardRef as ReactComponent };